<template>
    <div class="base-show-checkbox">

    </div>
</template>

<script>
    export default {
        
        name: 'base-show-checkbox',
        props: {
            isCheck: {
                type: Boolean,
                default: false
            }
        }
    }
</script>

<style scoped lang="scss">
    @import 'src/sass/index.scss';
    .base-show-checkbox{
        position: relative;
        width: 25px;
        height: 25px;
        background-color: #20a0ff;
        &::before{
            position: absolute;
            content: '';
            width: 16px;
            height: 8px;
            border: 2px solid #fff;
            border-right: none;
            border-top: none;
            left: 50%;
            top: 50%;
            transform: translate(-8px, -6px) rotate(-45deg);
            transform-origin: 50% 50%;
        }
    }
</style>
